// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderModal_orderModal__Y3GcS {
  padding: 0;
}
.OrderModal_orderModal__Y3GcS .modal__inner {
  height: 100%;
  border-radius: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.OrderModal_orderModal__Y3GcS .modal__inner .modal__header {
  padding: 24px 16px;
  border: none;
}
.OrderModal_orderModal__Y3GcS .modal__inner .modal__body {
  background: #FFF;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 0;
}
.OrderModal_orderModal__Y3GcS .modal__inner .modal__body .submitBlock {
  margin-top: auto;
}
.OrderModal_orderModal__Y3GcS .options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 1200px) {
  .OrderModal_orderModal__Y3GcS .options-list {
    gap: 24px;
  }
}
.OrderModal_orderModal__Y3GcS .checkbox-row p, .OrderModal_orderModal__Y3GcS .radio-row p {
  line-height: 114%;
  border: none;
}
.OrderModal_orderModal__Y3GcS .OrderModal_modal-text__JpcrW {
  font-size: 14px;
  line-height: 20px;
  color: #54575C;
}
.OrderModal_orderModal__swipeHandler__lWg9w {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.OrderModal_orderModal__swipeHandler__lWg9w span {
  border-radius: 8px;
  background: #FFF;
  width: 88px;
  height: 2px;
  z-index: 2;
  display: block;
  position: relative;
}
.OrderModal_orderModal__swipeHandler__lWg9w::before {
  content: "";
  position: absolute;
  bottom: -5vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 30vh;
  background: transparent;
}
.OrderModal_orderModal__top__71ydw {
  width: 100%;
  min-height: 216px;
  height: 55vw;
  max-height: 420px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.OrderModal_orderModal__top__71ydw .swiper {
  height: 100%;
}
.OrderModal_orderModal__top__71ydw .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0 6px;
  background: #D9D9D9;
  opacity: 0.4;
}
.OrderModal_orderModal__top__71ydw .swiper-pagination-bullet-active {
  background: #FAFAFA;
  opacity: 1;
}
.OrderModal_orderModal__top__71ydw .swiper-slide {
  width: 100%;
}
.OrderModal_orderModal__top__71ydw .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.OrderModal_orderModal__roundedTop__DJkFY {
  border-radius: 16px 16px 0 0;
}
.OrderModal_orderModal__body__8j53X {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;
  padding: 0 16px;
}
.OrderModal_orderModal__body_load__-Sgjb {
  gap: initial;
}
.OrderModal_orderModal__block__cMkSn {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 5px;
}
@media (min-width: 1200px) {
  .OrderModal_orderModal__block__cMkSn {
    margin-bottom: 24px;
  }
}
.OrderModal_orderModal__blockTitle__NsoZv {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .OrderModal_orderModal__blockTitle__NsoZv {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .OrderModal_orderModal__blockTitle__NsoZv {
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.OrderModal_orderModal__blockTitle__NsoZv::first-letter {
  text-transform: capitalize;
}
.OrderModal_orderModal__blockRequired__7V-sv {
  color: #f2200d;
}
.OrderModal_orderModal__submitBlock__OqKn- {
  padding: 16px;
  bottom: 0;
  left: 50%;
  background: #FFF;
  z-index: 2;
  position: sticky;
  width: 100%;
}
.OrderModal_orderModal__submitBlockHead__Mb44p {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.OrderModal_orderModal__submitBlockHead__Mb44p h5 {
  color: #151B26;
  line-height: 114%;
  font-size: 14px;
  font-weight: 600;
}
.OrderModal_orderModal__submitBlockHead__Mb44p p {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
}
.OrderModal_orderModal__submitBlockBottom__1ha5U {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.OrderModal_orderModal__calc__IjEID {
  height: 44px;
  width: 88px;
  min-width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #EEE;
  margin-right: 12px;
}
.OrderModal_orderModal__calcPlus__YggQi, .OrderModal_orderModal__calcMinus__2QJue {
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
}
.OrderModal_orderModal__calcPlus__YggQi:disabled, .OrderModal_orderModal__calcMinus__2QJue:disabled {
  opacity: 0.5;
}
.OrderModal_orderModal__calcNum__Wc2k5 {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  width: 32px;
  margin: 0 4px;
  text-align: center;
}
.OrderModal_orderModal__picker__j5tFO {
  width: 100%;
  position: relative;
}
.OrderModal_orderModal__picker__j5tFO img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  pointer-events: none;
}
@media (min-width: 640px) {
  .OrderModal_orderModal__picker__j5tFO img {
    right: 20px;
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 1200px) {
  .OrderModal_orderModal__picker__j5tFO img {
    width: 22px;
    height: 22px;
    right: 10px;
  }
}
.OrderModal_orderModal__picker__j5tFO input[type=date]:not(.OrderModal_has_value__i9dum)::-webkit-datetime-edit-fields-wrapper,
.OrderModal_orderModal__picker__j5tFO input[type=datetime-local]:not(.OrderModal_has_value__i9dum)::-webkit-datetime-edit-fields-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.OrderModal_orderModal__picker__j5tFO input[type=date]::-webkit-inner-spin-button,
.OrderModal_orderModal__picker__j5tFO input[type=datetime-local]::-webkit-inner-spin-button,
.OrderModal_orderModal__picker__j5tFO input[type=date]::-webkit-calendar-picker-indicator,
.OrderModal_orderModal__picker__j5tFO input[type=datetime-local]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.OrderModal_orderModal__picker__j5tFO input[type=date], .OrderModal_orderModal__picker__j5tFO input[type=datetime-local] {
  -webkit-appearance: none;
  width: -webkit-fill-available;
}
.OrderModal_orderModal__picker__j5tFO input[type=date]:not(.OrderModal_has_value__i9dum):before,
.OrderModal_orderModal__picker__j5tFO input[type=datetime-local]:not(.OrderModal_has_value__i9dum):before {
  content: attr(placeholder);
  color: #BEC0C2;
  width: 100%;
}
.OrderModal_orderModal__picker__j5tFO input[type=date]::after,
.OrderModal_orderModal__picker__j5tFO input[type=datetime-local]::after {
  position: absolute;
  right: 0;
  content: "";
  width: 20px;
  height: 100%;
  background: white;
  border-radius: 8px;
}
.OrderModal_orderModal__picker__j5tFO input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 10px;
  position: relative;
}
@media (min-width: 640px) {
  .OrderModal_orderModal__picker__j5tFO input {
    height: 64px;
    padding-left: 32px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .OrderModal_orderModal__picker__j5tFO input {
    height: 38px;
    padding-left: 10px;
    font-size: var(--fz-md);
    line-height: normal;
  }
}
.OrderModal_orderModal__picker__j5tFO input::placeholder {
  color: #BEC0C2;
}
.OrderModal_orderModal__picker__j5tFO .react-datepicker-wrapper {
  width: 100%;
}
.OrderModal_orderModal__sk1__srl8Y, .OrderModal_orderModal__sk2__RLx\\+Y, .OrderModal_orderModal__sk3__JevEW, .OrderModal_orderModal__sk4__\\+ZrfC {
  border-radius: 2px;
  height: 13px;
  width: 100%;
  margin-top: 8px;
}
.OrderModal_orderModal__sk2__RLx\\+Y {
  width: 85%;
  margin-top: 10px;
}
.OrderModal_orderModal__sk3__JevEW {
  width: 50%;
  margin-top: 10px;
}
.OrderModal_orderModal__sk4__\\+ZrfC {
  width: 20%;
  margin-top: 16px;
  margin-bottom: 9px;
}
.OrderModal_orderModal__sk5__OBd4A {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.OrderModal_orderModal__sk5__OBd4A span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
  margin-bottom: 4px;
}
.OrderModal_orderModal__sk5__OBd4A div {
  border-radius: 2px;
  height: 14px;
  width: calc(100% - 34px);
}
.OrderModal_orderModal__info__PtiQN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.OrderModal_orderModal__infoTitle__6jEks {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  color: var(--text-color);
}
.OrderModal_orderModal__infoText__yXh93 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  word-wrap: break-word;
}
.OrderModal_orderModal__infoText__yXh93 a {
  color: var(--accent-color);
  text-decoration: underline;
}
.OrderModal_orderModal__infoText__yXh93 ul, .OrderModal_orderModal__infoText__yXh93 ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.OrderModal_orderModal__infoText__yXh93 img {
  max-width: 100%;
}
.OrderModal_orderModal__infoText__yXh93 table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.OrderModal_orderModal__infoText__yXh93 table td, .OrderModal_orderModal__infoText__yXh93 table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.OrderModal_orderModal__infoText__yXh93 table td > *, .OrderModal_orderModal__infoText__yXh93 table th > * {
  margin-bottom: 0;
}
.OrderModal_orderModal__infoText__yXh93 table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.OrderModal_orderModal__infoText__yXh93 p {
  min-height: 20px;
}
.OrderModal_orderModal__infoText__yXh93 h1, .OrderModal_orderModal__infoText__yXh93 h2, .OrderModal_orderModal__infoText__yXh93 h3 {
  color: #303030;
}
.OrderModal_orderModal__infoText__yXh93 pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.OrderModal_orderModal__infoText__yXh93 code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}
.OrderModal_orderModal__files__373i2 {
  padding-top: 8px;
}
.OrderModal_orderModal__files__373i2 .orderModal__file {
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px 32px 8px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: var(--transition);
  margin-bottom: 8px;
}
.OrderModal_orderModal__files__373i2 .orderModal__file img {
  width: 15px;
  height: 21px;
}
.OrderModal_orderModal__file__Pp1re {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 8px;
  padding: 8px 32px 8px 4px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid transparent;
  position: relative;
  transition: var(--transition);
}
@media (hover: hover) {
  .OrderModal_orderModal__file__Pp1re:hover {
    border-color: var(--accent-color);
  }
}
.OrderModal_orderModal__fileContent__J\\+cFG {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
}
.OrderModal_orderModal__fileContent__J\\+cFG img {
  max-width: 24px;
  min-width: 24px;
}
.OrderModal_orderModal__fileIsLoading__loader__-ZHDH {
  height: 3px;
  background: #4084F8;
}
.OrderModal_orderModal__fileName__a5Xon {
  font-size: var(--fz-md);
  line-height: var(--lh-md);
}
.OrderModal_orderModal__fileSize__EGZLN {
  font-size: var(--fz-sm);
  line-height: 1;
  color: #7A808B;
  margin-top: 2px;
}
.OrderModal_orderModal__fileDelete__jaAeg {
  margin-left: auto;
  color: var(--error);
}
.OrderModal_orderModal__object__mFyt4 {
  border-radius: 12px;
  background: #FAFAFA;
  padding: 8px;
  display: flex;
  align-items: center;
}
.OrderModal_orderModal__objectIco__LJ6GD {
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
}
.OrderModal_orderModal__objectText__t-qLw span {
  font-size: 14px;
  line-height: 114%;
  color: #7A808B;
}
.OrderModal_orderModal__objectText__t-qLw p {
  font-size: 16px;
  color: #101618;
  line-height: 23.04px;
}
.OrderModal_orderModal__objectArrow__nlDIJ {
  margin-left: auto;
}
@media (min-width: 640px) {
  .OrderModal_orderModal__top__71ydw .swiper-pagination {
    bottom: 24px;
  }
  .OrderModal_orderModal__top__71ydw .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 12px;
    background: #D9D9D9;
    opacity: 0.4;
  }
  .OrderModal_orderModal__top__71ydw .swiper-pagination-bullet-active {
    background: #FAFAFA;
    opacity: 1;
  }
  .OrderModal_orderModal__body__8j53X {
    padding: 16px 24px 0;
  }
  .OrderModal_orderModal__submitBlock__OqKn- {
    padding: 24px;
    margin-left: -24px;
  }
  .OrderModal_orderModal__submitBlockHead__Mb44p h5 {
    font-size: 32px;
  }
  .OrderModal_orderModal__submitBlockHead__Mb44p p {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
  .OrderModal_orderModal__submitBlockBottom__1ha5U {
    margin-top: 18px;
  }
  .OrderModal_orderModal__calc__IjEID {
    border-radius: 16px;
    width: 195px;
    min-width: 195px;
    height: 76px;
    margin-right: 16px;
  }
  .OrderModal_orderModal__calcNum__Wc2k5 {
    width: 59px;
    height: 22px;
    margin: 0 16px;
    font-size: 28px;
  }
  .OrderModal_orderModal__calcPlus__YggQi, .OrderModal_orderModal__calcMinus__2QJue {
    width: 32px;
    height: 32px;
  }
  .OrderModal_orderModal__calcPlus__YggQi svg, .OrderModal_orderModal__calcMinus__2QJue svg {
    width: 32px;
    height: 32px;
  }
}
.OrderModal_orderModal__inputError__uEQhH.OrderModal_orderModal__inputError__uEQhH {
  border-color: #F2200D;
}
.OrderModal_orderModal__time__Sn8Au {
  font-size: 12px;
  padding: 2px 4px;
  min-height: auto;
}

.OrderModal_photoBlock__iSO3J {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
  position: relative;
}
@media (min-width: 1200px) {
  .OrderModal_photoBlock__iSO3J {
    grid-template-columns: repeat(6, 1fr);
  }
}
.OrderModal_photoBlock__append__Tj\\+2X {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 105px;
  cursor: pointer;
  background: rgba(var(--accent-color-rgb), 0.1);
}
.OrderModal_photoBlock__append__Tj\\+2X.OrderModal_error__ukqPs {
  border: 1px solid #F2200D;
}
.OrderModal_photoBlock__plus__5VV92 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-color);
  color: var(--accent-text-color);
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.OrderModal_photoBlock__preview__vPRBD {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.OrderModal_photoBlock__preview__vPRBD > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.OrderModal_photoBlock__close__InV\\+Y {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #E97676;
}
@media (min-width: 640px) {
  .OrderModal_photoBlock__append__Tj\\+2X, .OrderModal_photoBlock__preview__vPRBD {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .OrderModal_photoBlock__append__Tj\\+2X, .OrderModal_photoBlock__preview__vPRBD {
    height: 104px;
  }
}
.OrderModal_photoBlock__camera__EOmgZ {
  color: rgba(var(--accent-color-rgb), 0.45);
}
.OrderModal_photoBlock__error__IddB8 {
  position: initial !important;
  justify-content: flex-start !important;
}
.OrderModal_photoBlock__loader__0KcM1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.OrderModal_photoBlock__loader__precent__o9qGH {
  color: white;
  font-weight: 600;
  font-size: 12px;
  z-index: 1;
}
.OrderModal_photoBlock__loader__overlay__zF4as {
  position: absolute;
  background: rgba(178, 178, 178, 0.6784313725);
  width: 100%;
  height: 100%;
  top: 0;
}
.OrderModal_photoBlock__compressBlock__-lJAD {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}
.OrderModal_photoBlock__compressBlock__-lJAD svg {
  width: 24px;
  fill: none;
  animation-name: OrderModal_grow__RXtn0;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.OrderModal_photoBlock__compressBlock__-lJAD svg path {
  stroke: white;
}
.OrderModal_photoBlock__compressLoading__SIkhT {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 3;
}
.OrderModal_photoBlock__compressLoading__SIkhT svg {
  width: 24px;
  fill: none;
  animation-name: OrderModal_grow__RXtn0;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.OrderModal_photoBlock__compressLoading__SIkhT svg path {
  stroke: black;
}

@keyframes OrderModal_grow__RXtn0 {
  0% {
    scale: 1;
  }
  50% {
    scale: 2;
  }
  100% {
    scale: 1;
  }
}
@media (min-width: 1200px) {
  label.OrderModal_checkboxAlone__f2Eo9 {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  label.OrderModal_checkboxAlone__f2Eo9 p {
    width: auto;
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    padding-top: 5px;
    margin-right: 8px;
  }
}

@media (min-width: 1200px) {
  .OrderModal_orderModal__block__cMkSn .OrderModal_checkboxAlone__f2Eo9 p:last-child {
    margin-left: 0;
  }
}

.OrderModal_conditionList__oDF9Q {
  position: initial;
  overflow: hidden;
  transition: 0.15s;
}

.OrderModal_conditionList__container__-xNs1 {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .OrderModal_conditionList__container__-xNs1 {
    gap: 24px;
  }
}

.OrderModal_qrWrapBlock__Hwv9- {
  position: relative;
}
.OrderModal_qrWrapBlock__Hwv9- .OrderModal_qrWrapBlock__error__096kT {
  position: relative;
  justify-content: flex-start;
  margin: 0;
}
@media (min-width: 1200px) {
  .OrderModal_qrWrapBlock__Hwv9- .OrderModal_qrWrapBlock__error__096kT {
    position: absolute;
    top: 100%;
    left: 0;
    justify-content: flex-start;
    margin: 0;
  }
}

.OrderModal_qrBlock__oKb0Q {
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EAF7EF;
  width: max-content;
  cursor: pointer;
}
.OrderModal_qrBlock--error__XBkUI {
  color: var(--red);
}
.OrderModal_qrBlock__oKb0Q svg {
  width: 13px;
  height: 13px;
}
.OrderModal_qrBlock__oKb0Q svg path {
  fill: #2DBE64;
}

.OrderModal_QRInput__HYld- {
  position: relative;
}
.OrderModal_QRInput__HYld- input:disabled {
  background: none;
}
.OrderModal_QRInput__icon__7ZUaG {
  position: absolute;
  top: calc(50% - 16px);
  right: 10px;
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderModal/OrderModal.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AAEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAAN;AAEM;EACE,kBAAA;EACA,YAAA;AAAR;AAGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AADR;AAGQ;EACE,gBAAA;AADV;AAMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJN;AAMM;EALF;IAMI,SAAA;EAHN;AACF;AAOM;EACE,iBAAA;EACA,YAAA;AALR;AAUE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AARJ;AAWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AATJ;AAUI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AARN;AAUI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AARN;AAYE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AAVJ;AAaM;EACE,YAAA;AAXR;AAaU;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAXZ;AAaY;EACE,mBAAA;EACA,UAAA;AAXd;AAgBQ;EACE,WAAA;AAdV;AAeU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAbZ;AAoBE;EACE,4BAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,YAAA;AAnBN;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AApBJ;AAsBI;EANF;IAOI,mBAAA;EAnBJ;AACF;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AApBJ;AAsBI;EANF;IAOI,eAAA;EAnBJ;AACF;AAqBI;EAVF;IAWI,uBAAA;IACA,yBAAA;EAlBJ;AACF;AAoBI;EACE,0BAAA;AAlBN;AAsBE;EACE,cAAA;AApBJ;AAuBE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAtBJ;AAuBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AArBN;AAuBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AArBN;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;AA2BE;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA1BJ;AA2BI;EACE,YAAA;AAzBN;AA6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,kBAAA;AA5BJ;AA8BI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AA5BN;AA8BM;EAPF;IAQI,WAAA;IACA,WAAA;IACA,YAAA;EA3BN;AACF;AA6BM;EAbF;IAcI,WAAA;IACA,YAAA;IACA,WAAA;EA1BN;AACF;AA6BI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AA3BN;AA8BI;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AA5BN;AA+BK;EACC,wBAAA;EACA,6BAAA;AA7BN;AAiCI;;EAEE,0BAAA;EACA,cAAA;EACA,WAAA;AA/BN;AAmCI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAjCN;AAsCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AApCN;AAsCM;EAbF;IAcI,YAAA;IACA,kBAAA;IACA,eAAA;EAnCN;AACF;AAqCM;EAnBF;IAoBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;EAlCN;AACF;AAoCM;EACE,cAAA;AAlCR;AAuCM;EACE,WAAA;AArCR;AA0CE;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AA3CJ;AA8CE;EACE,UAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,UAAA;EACA,gBAAA;AA7CJ;AAgDE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AA/CJ;AAgDI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA9CN;AAiDI;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;AA/CN;AAmDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAnDJ;AAqDI;EACE,0BAAA;EACA,0BAAA;AAnDN;AAqDI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AAnDN;AAsDI;EACE,eAAA;AApDN;AAsDI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AApDN;AAuDI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AArDN;AAwDI;EACE,gBAAA;AAtDN;AAyDI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;AAvDN;AA0DI;EACE,gBAAA;AAxDN;AA2DI;EAGE,cAAA;AA3DN;AA6DI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AA3DN;AA6DI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AA3DN;AA+DE;EACE,gBAAA;AA7DJ;AAiEQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AA/DV;AAiEU;EACE,WAAA;EACA,YAAA;AA/DZ;AAsEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;AApEJ;AAsEI;EACE;IACE,iCAAA;EApEN;AACF;AAwEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;AAtEJ;AAwEI;EACE,eAAA;EACA,eAAA;AAtEN;AA2EI;EACE,WAAA;EACA,mBAAA;AAzEN;AA6EE;EACE,uBAAA;EACA,yBAAA;AA3EJ;AA8EE;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AA5EJ;AA+EE;EACE,iBAAA;EACA,mBAAA;AA7EJ;AAgFE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA9EJ;AAgFE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AA9EJ;AAiFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AA/EN;AAkFI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AAhFN;AAoFE;EACE,iBAAA;AAlFJ;AAqFE;EAKQ;IACE,YAAA;EAvFV;EAwFU;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;EAtFZ;EAwFY;IACE,mBAAA;IACA,UAAA;EAtFd;EA8FE;IACE,oBAAA;EA5FJ;EA+FE;IACE,aAAA;IACA,kBAAA;EA7FJ;EAiGI;IACE,eAAA;EA/FN;EAkGI;IACE,eAAA;IACA,uBAAA;EAhGN;EAoGE;IACE,gBAAA;EAlGJ;EAqGE;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;EAnGJ;EAsGE;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;EApGJ;EAuGE;IAEE,WAAA;IACA,YAAA;EAtGJ;EAuGI;IACE,WAAA;IACA,YAAA;EArGN;AACF;AAwGE;EACE,qBAAA;AAtGJ;AAyGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAvGJ;;AA2GA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;AAxGF;AA0GE;EANF;IAOI,qCAAA;EAvGF;AACF;AAyGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;AAvGJ;AAyGI;EACE,yBAAA;AAvGN;AA2GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzGJ;AA4GE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA1GJ;AA4GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AA1GN;AA8GE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AA5GJ;AAiHI;EAFF;IAGI,aAAA;EA9GJ;AACF;AAgHI;EANF;IAOI,aAAA;EA7GJ;AACF;AAgHE;EACE,0CAAA;AA9GJ;AAiHE;EACE,4BAAA;EACA,sCAAA;AA/GJ;AAkHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAhHJ;AAkHI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAhHN;AAmHI;EACE,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AAjHN;AAqHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAnHJ;AAqHI;EACE,WAAA;EACA,UAAA;EACA,sCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;AAnHN;AAqHM;EACE,aAAA;AAnHR;AAwHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,0CAAA;EACA,UAAA;AAtHJ;AAyHI;EACE,WAAA;EACA,UAAA;EACA,sCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;AAvHN;AAyHM;EACE,aAAA;AAvHR;;AA6HA;EACE;IACE,QAAA;EA1HF;EA6HA;IACE,QAAA;EA3HF;EA8HA;IACE,QAAA;EA5HF;AACF;AAgIE;EADF;IAEI,2BAAA;IACA,yBAAA;IACA,eAAA;EA7HF;AACF;AAgII;EADF;IAEI,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EA7HJ;AACF;;AAsIU;EADF;IAEI,cAAA;EAlIV;AACF;;AAyIA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;AAtIF;;AAyIA;EACE,aAAA;EACA,sBAAA;AAtIF;AAwIE;EAJF;IAKI,SAAA;EArIF;AACF;;AAwIA;EACE,kBAAA;AArIF;AAuIE;EACE,kBAAA;EACA,2BAAA;EACA,SAAA;AArIJ;AAuII;EALF;IAMI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,2BAAA;IACA,SAAA;EApIJ;AACF;;AAwIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AArIF;AAuIE;EACE,iBAAA;AArIJ;AAwIE;EACE,WAAA;EACA,YAAA;AAtIJ;AAwII;EACE,aAAA;AAtIN;;AA2IA;EACE,kBAAA;AAxIF;AA0IE;EACE,gBAAA;AAxIJ;AA2IE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAzIJ","sourcesContent":[".orderModal {\n  padding: 0;\n\n  :global {\n    .modal__inner {\n      height: 100%;\n      border-radius: 0;\n      max-width: none;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      .modal__header {\n        padding: 24px 16px;\n        border: none;\n      }\n\n      .modal__body {\n        background: #FFF;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        overflow: auto;\n        padding: 0;\n\n        .submitBlock {\n          margin-top: auto;\n        }\n      }\n    }\n\n    .options-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      @media (max-width: 1200px) {\n        gap: 24px;\n      }\n    }\n\n    .checkbox-row, .radio-row {\n      p {\n        line-height: 114%;\n        border: none;\n      }\n    }\n  }\n\n  .modal-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: #54575C;\n  }\n\n  &__swipeHandler {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    span {\n      border-radius: 8px;\n      background: #FFF;\n      width: 88px;\n      height: 2px;\n      z-index: 2;\n      display: block;\n      position: relative;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -5vh;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 30vh;\n      background: transparent;\n    }\n  }\n\n  &__top {\n    width: 100%;\n    min-height: 216px;\n    height: 55vw;\n    max-height: 420px;\n    border-radius: 16px 16px 0 0;\n    overflow: hidden;\n\n    :global {\n      .swiper {\n        height: 100%;\n        &-pagination {\n          &-bullet {\n            width: 6px;\n            height: 6px;\n            margin: 0 6px;\n            background: #D9D9D9;\n            opacity: 0.4;\n\n            &-active {\n              background: #FAFAFA;\n              opacity: 1;\n            }\n          }\n        }\n\n        &-slide {\n          width: 100%;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  &__roundedTop {\n    border-radius: 16px 16px 0 0;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 16px 16px 0 0;\n    padding: 0 16px;\n\n    &_load {\n      gap: initial;\n    }\n  }\n  &__block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 5px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 24px;\n    }\n  }\n\n  &__blockTitle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    padding-bottom: 4px;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__blockRequired {\n    color: #f2200d;\n  }\n\n  &__submitBlock {\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    background: #FFF;\n    z-index: 2;\n    position: sticky;\n    width: 100%;\n  }\n\n  &__submitBlockHead {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h5 {\n      color: #151B26;\n      line-height: 114%;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__submitBlockBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n  }\n\n  &__calc {\n    height: 44px;\n    width: 88px;\n    min-width: 88px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: #EEE;\n    margin-right: 12px;\n  }\n\n  &__calcPlus,\n  &__calcMinus {\n    width: 16px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  &__calcNum {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: #000;\n    width: 32px;\n    margin: 0 4px;\n    text-align: center;\n  }\n\n  &__picker {\n    width: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n      pointer-events: none;\n\n      @media (min-width: 640px) {\n        right: 20px;\n        width: 32px;\n        height: 32px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 22px;\n        height: 22px;\n        right: 10px;\n      }\n    }\n\n    input[type=\"date\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper,\n    input[type=\"datetime-local\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator,\n    input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n     input[type=\"date\"], input[type=\"datetime-local\"] {\n      -webkit-appearance: none;\n      width: -webkit-fill-available;\n     }\n\n    // Отображение placeholder у инпутов с типом даты\n    input[type=\"date\"]:not(.has_value):before, \n    input[type=\"datetime-local\"]:not(.has_value):before {\n      content: attr(placeholder);\n      color: #BEC0C2;\n      width: 100%;\n    }\n\n    // Блок для закрытия стрелки на мобилках\n    input[type=\"date\"]::after,\n    input[type=\"datetime-local\"]::after {\n      position: absolute;\n      right: 0;\n      content: \"\";\n      width: 20px;\n      height: 100%;\n      background: white;\n      border-radius: 8px;\n    }\n\n  \n\n    input {\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      border: 1px solid #E8ECEE;\n      background: #FFF;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n      padding: 3px 10px;\n      position: relative;\n\n      @media (min-width: 640px) {\n        height: 64px;\n        padding-left: 32px;\n        font-size: 20px;\n      }\n\n      @media (min-width: 1200px) {\n        height: 38px;\n        padding-left: 10px;\n        font-size: var(--fz-md);\n        line-height: normal;\n      }\n\n      &::placeholder {\n        color: #BEC0C2;\n      }\n    }\n\n    :global {\n      .react-datepicker-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  &__sk1,\n  &__sk2,\n  &__sk3,\n  &__sk4 {\n    border-radius: 2px;\n    height: 13px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  &__sk2 {\n    width: 85%;\n    margin-top: 10px;\n  }\n\n  &__sk3 {\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  &__sk4 {\n    width: 20%;\n    margin-top: 16px;\n    margin-bottom: 9px;\n  }\n\n  &__sk5 {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n    span {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      display: block;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n\n    div {\n      border-radius: 2px;\n      height: 14px;\n      width: calc(100% - 34px);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__infoTitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    color: var(--text-color);\n  }\n\n  &__infoText {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    word-wrap: break-word;\n\n    a {\n      color: var(--accent-color);\n      text-decoration: underline;\n    }\n    ul, ol{\n      margin: 0;\n      padding: 0;\n      padding-left: 16px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n    table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      width: 100%;\n      margin: 0;\n      overflow: hidden\n    }\n\n    table td,table th {\n      min-width: 1em;\n      border: 2px solid #ced4da;\n      padding: 3px 5px;\n      vertical-align: top;\n      box-sizing: border-box;\n      position: relative\n    }\n\n    table td>*,table th>* {\n      margin-bottom: 0\n    }\n\n    table th {\n      font-weight: 700;\n      text-align: left;\n      background-color: #f1f3f5\n    }\n\n    p {\n      min-height: 20px;\n    }\n\n    & h1,\n    & h2,\n    & h3 {\n      color: #303030;\n    }\n    pre {\n      background: #2b2a2a;\n      color: #fff;\n      padding: 8px;\n      display: flex;\n      border-radius: 8px;\n      width: 100%;\n      white-space: pre-wrap;\n    }\n    code {\n      width: 100%;\n      display: block;\n      color: #fff;\n      background-color: #f1f3f5;\n    }\n  }\n\n  &__files {\n    padding-top: 8px;\n\n    :global {\n      .orderModal {\n        &__file {\n          flex-direction: row;\n          flex-wrap: nowrap;\n          padding: 8px 32px 8px 4px;\n          border-radius: 12px;\n          border: 1px solid transparent;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          transition: var(--transition);\n          margin-bottom: 8px;\n\n          img {\n            width: 15px;\n            height: 21px;\n          }\n        }\n      }\n    }\n  }\n\n  &__file {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 2px;\n    margin-bottom: 8px;\n    padding: 8px 32px 8px 4px;\n    background: var(--white);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    position: relative;\n    transition: var(--transition);\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &__fileContent {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n\n    img {\n      max-width: 24px;\n      min-width: 24px;\n    }\n  }\n\n  &__fileIsLoading {\n    &__loader {\n      height: 3px;\n      background: #4084F8;\n    }\n  }\n\n  &__fileName {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n  }\n\n  &__fileSize {\n    font-size: var(--fz-sm);\n    line-height: 1;\n    color: #7A808B;\n    margin-top: 2px;\n  }\n\n  &__fileDelete {\n    margin-left: auto;\n    color: var(--error);\n  }\n\n  &__object {\n    border-radius: 12px;\n    background: #FAFAFA;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n  }\n  &__objectIco {\n    width: 26px;\n    min-width: 26px;\n    height: 26px;\n    margin-right: 8px;\n  }\n  &__objectText {\n    span {\n      font-size: 14px;\n      line-height: 114%;\n      color: #7A808B;\n    }\n\n    p {\n      font-size: 16px;\n      color: #101618;\n      line-height: 23.04px;\n    }\n  }\n\n  &__objectArrow {\n    margin-left: auto;\n  }\n\n  @media (min-width: 640px) {\n\n    &__top {\n      :global {\n        .swiper {\n          &-pagination {\n            bottom: 24px;\n            &-bullet {\n              width: 12px;\n              height: 12px;\n              margin: 0 12px;\n              background: #D9D9D9;\n              opacity: 0.4;\n    \n              &-active {\n                background: #FAFAFA;\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__body {\n      padding: 16px 24px 0;\n    }\n\n    &__submitBlock {\n      padding: 24px;\n      margin-left: -24px;\n    }\n\n    &__submitBlockHead {\n      h5 {\n        font-size: 32px;\n      }\n\n      p {\n        font-size: 28px;\n        letter-spacing: -0.56px;\n      }\n    }\n\n    &__submitBlockBottom {\n      margin-top: 18px;\n    }\n\n    &__calc {\n      border-radius: 16px;\n      width: 195px;\n      min-width: 195px;\n      height: 76px;\n      margin-right: 16px;\n    }\n\n    &__calcNum {\n      width: 59px;\n      height: 22px;\n      margin: 0 16px;\n      font-size: 28px;\n    }\n\n    &__calcPlus,\n    &__calcMinus {\n      width: 32px;\n      height: 32px;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }\n  &__inputError.orderModal__inputError{\n    border-color: #F2200D;\n  }\n\n  &__time {\n    font-size: 12px;\n    padding: 2px 4px;\n    min-height: auto;\n  }\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n  position: relative;\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  &__append {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    height: 105px;\n    cursor: pointer;\n    background: rgba(var(--accent-color-rgb), 0.1);\n\n    &.error {\n      border: 1px solid #F2200D;\n    }\n  }\n\n  &__plus {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--accent-color);\n    color: var(--accent-text-color);\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__preview {\n    height: 105px;\n    border-radius: 8px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    &>img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    background: #E97676;\n  }\n\n  &__append,\n  &__preview {\n    @media (min-width: 640px) {\n      height: 140px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 104px;\n    }\n  }\n\n  &__camera {\n    color: rgba(var(--accent-color-rgb), 0.45)\n  }\n\n  &__error {\n    position: initial !important;\n    justify-content: flex-start !important;\n  }\n\n  &__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &__precent {\n      color: white;\n      font-weight: 600;\n      font-size: 12px;\n      z-index: 1;\n    }\n\n    &__overlay {\n      position: absolute;\n      background: #b2b2b2ad;\n      width: 100%;\n      height: 100%;\n      top: 0;\n    }\n  }\n\n  &__compressBlock {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 60px;\n    height: 60px;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1;\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: white;\n      }\n    }\n  }\n\n  &__compressLoading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(255,255,255, 0.8);\n    z-index: 3;\n\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: black;\n      }\n    }\n  }\n}\n\n@keyframes grow {\n  0% {\n    scale: (1);\n  }\n\n  50% {\n    scale: (2);\n  }\n\n  100% {\n    scale: (1);\n  }\n}\n\nlabel.checkboxAlone {\n  @media (min-width: 1200px) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n\n  p {\n    @media (min-width: 1200px) {\n      width: auto;\n      font-weight: 500;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n      padding-top: 5px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.orderModal {\n  &__block {\n    .checkboxAlone {\n      p {\n        &:last-child {\n          @media (min-width: 1200px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n.qrWrapBlock {\n  position: relative;\n\n  .qrWrapBlock__error {\n    position: relative;\n    justify-content: flex-start;\n    margin: 0;\n\n    @media (min-width: 1200px) {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      justify-content: flex-start;\n      margin: 0;\n    }\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n\n  &--error {\n    color: var(--red);\n  }\n\n  svg {\n    width: 13px;\n    height: 13px;\n\n    path {\n      fill: #2DBE64;\n    }\n  }\n}\n\n.QRInput {\n  position: relative;\n\n  input:disabled {\n    background: none;\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(50% - 16px);\n    right: 10px;\n    background: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderModal": `OrderModal_orderModal__Y3GcS`,
	"modal-text": `OrderModal_modal-text__JpcrW`,
	"orderModal__swipeHandler": `OrderModal_orderModal__swipeHandler__lWg9w`,
	"orderModal__top": `OrderModal_orderModal__top__71ydw`,
	"orderModal__roundedTop": `OrderModal_orderModal__roundedTop__DJkFY`,
	"orderModal__body": `OrderModal_orderModal__body__8j53X`,
	"orderModal__body_load": `OrderModal_orderModal__body_load__-Sgjb`,
	"orderModal__block": `OrderModal_orderModal__block__cMkSn`,
	"orderModal__blockTitle": `OrderModal_orderModal__blockTitle__NsoZv`,
	"orderModal__blockRequired": `OrderModal_orderModal__blockRequired__7V-sv`,
	"orderModal__submitBlock": `OrderModal_orderModal__submitBlock__OqKn-`,
	"orderModal__submitBlockHead": `OrderModal_orderModal__submitBlockHead__Mb44p`,
	"orderModal__submitBlockBottom": `OrderModal_orderModal__submitBlockBottom__1ha5U`,
	"orderModal__calc": `OrderModal_orderModal__calc__IjEID`,
	"orderModal__calcPlus": `OrderModal_orderModal__calcPlus__YggQi`,
	"orderModal__calcMinus": `OrderModal_orderModal__calcMinus__2QJue`,
	"orderModal__calcNum": `OrderModal_orderModal__calcNum__Wc2k5`,
	"orderModal__picker": `OrderModal_orderModal__picker__j5tFO`,
	"has_value": `OrderModal_has_value__i9dum`,
	"orderModal__sk1": `OrderModal_orderModal__sk1__srl8Y`,
	"orderModal__sk2": `OrderModal_orderModal__sk2__RLx+Y`,
	"orderModal__sk3": `OrderModal_orderModal__sk3__JevEW`,
	"orderModal__sk4": `OrderModal_orderModal__sk4__+ZrfC`,
	"orderModal__sk5": `OrderModal_orderModal__sk5__OBd4A`,
	"orderModal__info": `OrderModal_orderModal__info__PtiQN`,
	"orderModal__infoTitle": `OrderModal_orderModal__infoTitle__6jEks`,
	"orderModal__infoText": `OrderModal_orderModal__infoText__yXh93`,
	"orderModal__files": `OrderModal_orderModal__files__373i2`,
	"orderModal__file": `OrderModal_orderModal__file__Pp1re`,
	"orderModal__fileContent": `OrderModal_orderModal__fileContent__J+cFG`,
	"orderModal__fileIsLoading__loader": `OrderModal_orderModal__fileIsLoading__loader__-ZHDH`,
	"orderModal__fileName": `OrderModal_orderModal__fileName__a5Xon`,
	"orderModal__fileSize": `OrderModal_orderModal__fileSize__EGZLN`,
	"orderModal__fileDelete": `OrderModal_orderModal__fileDelete__jaAeg`,
	"orderModal__object": `OrderModal_orderModal__object__mFyt4`,
	"orderModal__objectIco": `OrderModal_orderModal__objectIco__LJ6GD`,
	"orderModal__objectText": `OrderModal_orderModal__objectText__t-qLw`,
	"orderModal__objectArrow": `OrderModal_orderModal__objectArrow__nlDIJ`,
	"orderModal__inputError": `OrderModal_orderModal__inputError__uEQhH`,
	"orderModal__time": `OrderModal_orderModal__time__Sn8Au`,
	"photoBlock": `OrderModal_photoBlock__iSO3J`,
	"photoBlock__append": `OrderModal_photoBlock__append__Tj+2X`,
	"error": `OrderModal_error__ukqPs`,
	"photoBlock__plus": `OrderModal_photoBlock__plus__5VV92`,
	"photoBlock__preview": `OrderModal_photoBlock__preview__vPRBD`,
	"photoBlock__close": `OrderModal_photoBlock__close__InV+Y`,
	"photoBlock__camera": `OrderModal_photoBlock__camera__EOmgZ`,
	"photoBlock__error": `OrderModal_photoBlock__error__IddB8`,
	"photoBlock__loader": `OrderModal_photoBlock__loader__0KcM1`,
	"photoBlock__loader__precent": `OrderModal_photoBlock__loader__precent__o9qGH`,
	"photoBlock__loader__overlay": `OrderModal_photoBlock__loader__overlay__zF4as`,
	"photoBlock__compressBlock": `OrderModal_photoBlock__compressBlock__-lJAD`,
	"grow": `OrderModal_grow__RXtn0`,
	"photoBlock__compressLoading": `OrderModal_photoBlock__compressLoading__SIkhT`,
	"checkboxAlone": `OrderModal_checkboxAlone__f2Eo9`,
	"conditionList": `OrderModal_conditionList__oDF9Q`,
	"conditionList__container": `OrderModal_conditionList__container__-xNs1`,
	"qrWrapBlock": `OrderModal_qrWrapBlock__Hwv9-`,
	"qrWrapBlock__error": `OrderModal_qrWrapBlock__error__096kT`,
	"qrBlock": `OrderModal_qrBlock__oKb0Q`,
	"qrBlock--error": `OrderModal_qrBlock--error__XBkUI`,
	"QRInput": `OrderModal_QRInput__HYld-`,
	"QRInput__icon": `OrderModal_QRInput__icon__7ZUaG`
};
export default ___CSS_LOADER_EXPORT___;
